import { render, staticRenderFns } from "./AppSettingsNav.vue?vue&type=template&id=800a6160&"
import script from "./AppSettingsNav.vue?vue&type=script&lang=ts&"
export * from "./AppSettingsNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports